<script setup>
import { ref, computed, onBeforeMount, watch, defineEmits, watchEffect, toRefs, reactive, defineProps } from 'vue'

import { useAlert } from '@/composables/useAlert'
import { Funcionarios } from '@/stores/funcionarios'
import { Cargos } from '@/stores/cargos'
import { Patios } from '@/stores/patios'
import { UnidadesLotacoes } from '@/stores/unidadesLotacoes'

import ToggleButton from 'primevue/togglebutton'

const { alertWarn } = useAlert()

const { ActionbterFuncionariosFiltro } = Funcionarios()
const { ActionObterPatios } = Patios()
const { ActionObterCargos } = Cargos()
const { ActionObterUnidadeLotacao } = UnidadesLotacoes()

const { funcionariosFiltro } = toRefs(Funcionarios())
const { patios } = toRefs(Patios())
const { cargos } = toRefs(Cargos())
const { unidadeLotacao } = toRefs(UnidadesLotacoes())

const active = ref(false)

const filtroIndividual = ref(true)
const filtroColetivo = ref(false)
const filtroTodos = ref(false)

const funcionario = ref(null)

const multselectsColetivo = reactive([
  {
    value: [],
    options: computed(() => patios.value?.items),
    placeholder: 'Sedes'
  },
  {
    value: [],
    options: computed(() => cargos.value?.items),
    placeholder: 'Cargos'
  },
  {
    value: [],
    options: computed(() => unidadeLotacao.value?.items),
    placeholder: 'Unidade Lotação'
  }
])

const carregarCamposColetivo = async () => {
  await ActionObterPatios({ pagina: 1, limte: 1000 })
  await ActionObterCargos()
  await ActionObterUnidadeLotacao()
}

const pesquisarFuncionario = async (event) => {
  try {
    const filtro = `${event.query.trim()}&${props.idReferencia}`
    await ActionbterFuncionariosFiltro(filtro)
  } catch (error) {
    alertWarn('Funcionário não encontrado')
  }
}

const payloadSelecao = computed(() => ({
  tipoSelecao: filtroIndividual.value ? 1 : filtroColetivo.value ? 2 : filtroTodos ? 3 : 1,
  matricula: funcionario.value?.matricula,
  patios: multselectsColetivo[0].value.map((c) => c.id).join(',') ?? '',
  cargos: multselectsColetivo[1].value.map((c) => c.id).join(',') ?? '',
  unidades: multselectsColetivo[2].value.map((c) => c.id).join(',') ?? ''
}))

const emit = defineEmits(['payloadSelecao'])

watchEffect(() => emit('payloadSelecao', payloadSelecao.value))

watch(
  () => filtroIndividual.value,
  () => {
    if (filtroIndividual.value === true) {
      filtroColetivo.value = false
      filtroTodos.value = false
    }
  }
)

watch(
  () => filtroColetivo.value,
  () => {
    if (filtroColetivo.value === true) {
      filtroIndividual.value = false
      filtroTodos.value = false
    }
  }
)

watch(
  () => filtroTodos.value,
  () => {
    if (filtroTodos.value === true) {
      filtroColetivo.value = false
      filtroIndividual.value = false
      funcionario.value = null
      multselectsColetivo.forEach((e) => (e.value = []))
    }
  }
)
onBeforeMount(carregarCamposColetivo)
const props = defineProps(['idReferencia'])
</script>
<template>
  <div class="container-filtro-selecao">
    <Progress :active="active" />
    <Divider align="left">
      <div class="inline-flex align-items-center">
        <i class="pi pi-shield mr-2"></i>
        Seleção
      </div>
    </Divider>
    <div class="block-filtro-selecao">
      <div class="troggles-selecao">
        <div class="field">
          <ToggleButton v-model="filtroIndividual" onLabel="Individual" offLabel="Individual" />
        </div>
        <div class="field">
          <ToggleButton v-model="filtroColetivo" onLabel="Coletivo" offLabel="Coletivo" />
        </div>
        <div class="field">
          <ToggleButton v-model="filtroTodos" onLabel="Todos" offLabel="Todos" />
        </div>
      </div>
      <div class="block-fields-individual" v-if="filtroIndividual">
        <div class="field-autocomplete">
          <AutoComplete
            id="nc-funcionarios"
            inputStyle="width: 100%;outline:none; "
            inputClass="nc-input-autocomplete"
            inputId="nc-txt-funcionarios"
            class="nc-autocomplete"
            v-model="funcionario"
            :suggestions="funcionariosFiltro"
            @complete="pesquisarFuncionario($event)"
            optionLabel="completo"
            field="completo"
            placeholder="Procurar por matricula ou nome"
          />
        </div>
      </div>
      <div class="block-fields-coletivo" v-if="filtroColetivo">
        <div class="field" v-for="item of multselectsColetivo" :key="item.placeholder">
          <MultiSelect
            :virtualScrollerOptions="{ itemSize: 50 }"
            v-model="item.value"
            :options="item.options"
            optionLabel="descricao"
            :filter="true"
            :placeholder="item.placeholder"
            class="multiselect-custom"
            emptyFilterMessage="Nenhum registro encontrado"
          />
        </div>
      </div>
      <div class="block-fields-todos" v-if="filtroTodos"></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.container-filtro-selecao {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
}
.block-filtro-selecao {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.troggles-selecao,
.block-fields-coletivo,
.block-fields-todos,
.block-fields-individual {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 50px;
}
.field {
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  width: 200px;
}
.block-fields-individual,
.nc-autocomplete {
  width: 410px;
}
</style>
